import { render, staticRenderFns } from "./EventHeroVideo.vue?vue&type=template&id=06e12b6a&scoped=true&"
import script from "./EventHeroVideo.vue?vue&type=script&lang=js&"
export * from "./EventHeroVideo.vue?vue&type=script&lang=js&"
import style0 from "./EventHeroVideo.vue?vue&type=style&index=0&id=06e12b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e12b6a",
  null
  
)

export default component.exports